'use client'
import { CDN_URL } from '@paladise/config/constants'
import {
  getSubscriptionsProducts,
  getUserSubscription,
  getUserSubscriptionList,
} from 'api/purchase'
import Logo from 'components/Logo'
import { ROUTE_PATH } from 'config/routerPath'
import { ISubscription, SourceEnum } from 'features/payment/type'
import PlansPage from 'features/plans/PlansPage'
import { IProduct } from 'features/purchase/constants'
import { clientFetch } from 'lib/fetch/client'
import { useRouter } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { isEmbed, session } from 'store/server-context/static'

export default function Page() {
  const [hsaIosSubscription, setHsaIosSubscription] = useState(false)
  const [plansMap, setPlansMap] = useState<Record<string, IProduct> | null>(
    null,
  )
  const [userSubscription, setUserSubscription] =
    useState<ISubscription | null>(null)
  const { push } = useRouter()

  const handleInit = async () => {
    const products = await getSubscriptionsProducts(clientFetch)

    const plansMap = products.reduce(
      (pre, cur) => {
        pre[`${cur.plan_id}`] = cur
        return pre
      },
      {} as Record<string, IProduct>,
    )

    const res = await getUserSubscriptionList(clientFetch)

    const userSubscription = res.reduce((pre, cur) => {
      if (cur.source === SourceEnum.appstore && plansMap[cur.plan].id) {
        setHsaIosSubscription(true)
      }
      if (plansMap[cur.renew_plan_id]?.id) {
        pre = cur
      }
      return pre
    }, {} as ISubscription)

    setUserSubscription(userSubscription)
    setPlansMap(plansMap)
  }

  useEffect(() => {
    handleInit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.userId])

  if (!userSubscription || !plansMap)
    return (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="bg-overlay-still flex h-24 w-24 items-center justify-center rounded-full">
            <span className="i-ps-cell_loading animate-spin text-[#FAFDFF] [--icon-size:32px]" />
          </div>
        </div>
      </>
    )

  return (
    <>
      <div className="min768:mx-12 px-4 pb-4 pt-5">
        <Logo
          className="cursor-pointer"
          onClick={() => {
            !isEmbed && push(ROUTE_PATH.SIDEBAR.FEED)
          }}
        />
      </div>
      <PlansPage
        plansMap={plansMap}
        userSubscription={userSubscription}
        hsaIosSubscription={hsaIosSubscription}
      />
    </>
  )
}
